export default __webpack_public_path__ + "static/media/player (1) 1.995ecf90.svg";